import React from "react";
import "../Events.css";

const TestimonialFilter = (props) => {
  return (
    <>
      <div className="AthleteSearchBanner main-filter-event testimonial-title">
        <h1>Testimonials</h1>
        <div className="AthleteSearchFilterContainer">
          {/* <Input
            icon="search"
            placeholder="Search Wiki..."
            name="filteredSearch"
            onChange={(e) =>
              props.searchQuery(e.target.value.trim().toLowerCase())
            }
            autoComplete="off"
          /> */}
        </div>
      </div>
    </>
  );
};

export default TestimonialFilter;
